import React from 'react'
import { VerificationAccountHomePage } from '@mobi/account/Areas/VerificationAccount'
import { useBetAccount } from '@mobi/account/Hooks'
import { useDisableAppHeaderRender } from '../../Areas/AppHeader/hooks/useDisableAppHeaderRender'
import { useLogon } from '../../Utils/hooks'

export const VerificationAccountGate = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn, accountNumber } = useLogon()
  const enabled = isLoggedIn === true && accountNumber !== null
  const { data: betAccount, isError: isBetAccountError } = useBetAccount({ enabled })
  const isVerificationAccount = betAccount?.IdVerificationOnlyInd?.toUpperCase() === 'Y'

  if (isLoggedIn && (isVerificationAccount || isBetAccountError)) {
    return (
      <VerificationAccountHomePage
        betAccountNumber={betAccount?.BetAccountNumber}
        useDisableAppHeaderRender={useDisableAppHeaderRender}
        isBetAccountError={isBetAccountError}
      />
    )
  }

  return <>{children}</>
}
